// extracted by mini-css-extract-plugin
module.exports = {"profileContainer":"profile_profileContainer__2rdVn","profileData":"profile_profileData__3Z9pW","profilePic":"profile_profilePic__12kJ8"};